import { render, staticRenderFns } from "./FormulaTooltip.vue?vue&type=template&id=7225c9a8&scoped=true&"
import script from "./FormulaTooltip.vue?vue&type=script&setup=true&lang=js&"
export * from "./FormulaTooltip.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./FormulaTooltip.vue?vue&type=style&index=0&id=7225c9a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7225c9a8",
  null
  
)

export default component.exports